import React, {Component} from "react";
import {InvoiceService} from "../../../../service/admin/invoice/InvoiceService";
import EditParameters from "./EditParametersView";
import {
    EDIT_INSTITUTION_ROUTE,
    EDIT_PARAMETERS_ROUTE,
    INVOICE_ROUTE
} from "../../../../utils/constants/RoutesConstants";
import {Button} from "primereact/button";
import {Growl} from "primereact/growl";
import {withoutComma} from "../../../../utils/calculate/Amount";

export default class EditParametersContainer extends Component {
    constructor(props) {
        super(props);

        this.invoiceService = new InvoiceService();

        this.loading = this.loading.bind(this);
        this.returnInvoice = this.returnInvoice.bind(this);
        this.getPercent = this.getPercent.bind(this);
        this.getInstitutionInvoice = this.getInstitutionInvoice.bind(this);
        this.saveDataPercent = this.saveDataPercent.bind(this);
        this.updatePercent = this.updatePercent.bind(this);
        this.redirectEditInstitutionInvoice = this.redirectEditInstitutionInvoice.bind(this);
        this.institutionInvoiceActionTemplate = this.institutionInvoiceActionTemplate.bind(this);

        this.state = {
            isLoading: true,
            percentPtm: {},
            percentPtt: {},
            institutionList: [],
        };

        this.getPercent();
        this.getInstitutionInvoice();
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
    }

    returnInvoice(message) {
        this.props.history.push({
            pathname: INVOICE_ROUTE,
            message: message,
        });
    }

    getPercent() {
        this.loading(true);
        this.invoiceService.getPercent().then(response => {
            let percentPtm = response.payload[0];
            percentPtm['porcentaje'] = response.payload[0].porcentaje * 100;
            let percentPtt = response.payload[1];
            percentPtt['porcentaje'] = response.payload[1].porcentaje * 100;
            this.setState({
                percentPtm: percentPtm,
                percentPtt: percentPtt
            });
            this.loading(false);
        });
    }

    getInstitutionInvoice() {
        this.loading(true);
        this.invoiceService.getInstitutionInvoice().then(response => {
            this.setState({
                institutionList: response.payload,
            });
            this.loading(false);
        });
    }

    redirectEditInstitutionInvoice(rowData) {
        this.props.history.push({
            pathname: EDIT_INSTITUTION_ROUTE,
            state: {
                returnPath: EDIT_PARAMETERS_ROUTE,
                selectedInstitution: rowData,
            }
        });
    }

    institutionInvoiceActionTemplate(rowData, column) {
        return (
            <Button label="Editar"
                    className="p-button-secondary"
                    onClick={() => this.redirectEditInstitutionInvoice(rowData)}
            />
        );
    }

    saveDataPercent(event) {
        const {name, value} = event.target;
        let percentData = this.state[name];
        percentData = {
            rol: percentData['rol'],
            porcentaje: value,
        };
        this.setState({
            [name]: percentData,
        })
    }

    updatePercent() {
        if (withoutComma(this.state.percentPtt.porcentaje) > 0 &&
            withoutComma(this.state.percentPtm.porcentaje) > 0) {
            this.loading(true);
            this.invoiceService.updatePercent(this.state.percentPtm, this.state.percentPtt)
                .then(resp => {
                    if (resp.message && resp.message === 'Success') {
                        let message = {
                            severity: 'success',
                            summary: 'Éxito',
                            detail: 'Se ha actualizado su solicitud con éxito.',
                        };
                        this.returnInvoice(message);
                    } else if (resp.error && resp.error !== '') {
                        this.growl.show({
                            severity: 'error', summary: 'Error.',
                            detail: resp.error
                        });
                    }
                    this.loading(false);
                });
        } else {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: "Debe llenar los campos requeridos correctamente"
            });
        }
    };

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        return <EditParameters
            isLoading={this.state.isLoading}
            loading={this.loading}
            returnInvoice={this.returnInvoice}
            percentPtm={this.state.percentPtm}
            percentPtt={this.state.percentPtt}
            institutionList={this.state.institutionList}
            institutionInvoiceActionTemplate={this.institutionInvoiceActionTemplate}
            saveDataPercent={this.saveDataPercent}
            updatePercent={this.updatePercent}
            messagesGrowl={messagesGrowl}
        />
    }
};
